import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { nurseHandoverSetting, nurseHOMst } from "../../../interfaces/masters/nursehandover";
import { Employee } from "../../../interfaces/masters/employee";

@Injectable()
export class NurseHandOverApi {
    constructor(private api: HttpService){}


    get(url:string,queryparams:HttpParams): Observable<{nhO_Setting:nurseHandoverSetting[],nurseInfo:Employee[],transList:nurseHOMst[],nurseSign:{empId:string,signature:string}[]}>{
        let header=new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
      }
    
      add(url:string, data: nurseHOMst): Observable<{nhO_Setting:nurseHandoverSetting[],nurseInfo:Employee[],transList:nurseHOMst[],nurseSign:{empId:string,signature:string}[]}>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.post( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
      }
    
      update(url:string, data: nurseHOMst,queryparams:HttpParams): Observable<{nhO_Setting:nurseHandoverSetting[],nurseInfo:Employee[],transList:nurseHOMst[],nurseSign:{empId:string,signature:string}[]}>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.post( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
      }
}